module.exports = __webpack_public_path__ + "static/media/close.3e8948a6.png";